import { render, staticRenderFns } from "./veStuGraduationYxbys.vue?vue&type=template&id=7fb0890b&scoped=true"
import script from "./veStuGraduationYxbys.vue?vue&type=script&lang=js"
export * from "./veStuGraduationYxbys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0890b",
  null
  
)

export default component.exports